import styled from "@emotion/styled";
import { Theme } from "@yuno/design-system-web";
import { PaymentRow } from "../common/payment-row";
import aplazo from "../../../../assets/styling/a.svg";
import visa from "../../../../assets/styling/visa.svg";
import card from "../../../../assets/styling/card-add.svg";
import addi from "../../../../assets/styling/addi.svg";
import bancolombia from "../../../../assets/styling/bancolombia.svg";
import mp from "../../../../assets/styling/mp.svg";
import pix from "../../../../assets/styling/pix.svg";
import paypal from "../../../../assets/styling/paypal.svg";
import master from "../../../../assets/styling/master.svg";
import nu from "../../../../assets/styling/nu.svg";
/* import plus from "../../../../assets/styling/plus.svg";
import grouped from "../../../../assets/styling/grouped.svg"; */
import { CustomTheme } from "../../../../types/custom-theme";
import { useContext } from "react";
import { ThemeContext } from "../../../../context/theme-context";

const Container = styled.div<{ theme?: Theme; customTheme: CustomTheme }>`
  border-radius: ${({ customTheme }) =>
    customTheme.payment_form.container.edge_radius}px;
  border: ${({ customTheme }) =>
    `${customTheme.payment_form.container.edge_weight}px solid ${customTheme.payment_form.container.edge_color}`};
  background-color: ${({ customTheme }) =>
    customTheme.payment_form.settings.background_color};
  padding-left: 24px;
  padding-top: 4px;
  padding-right: 21px;

  img.meta {
    object-fit: contain;
    width: 76px;
    height: 20px;
  }

  p.meta {
    color: #6c6f75;
  }
`;

const payments = [
  { title: "Mastercard ****3400", img: master },
  { title: "Visa ****1234", img: visa },
  { title: "Add new card", img: card },
  { title: "Paypal", img: paypal },
  { title: "NuPay", img: nu },
  { title: "Bancolombia", img: bancolombia },
  { title: "Pix", img: pix },
  { title: "ADDI", img: addi },
  { title: "Mercado Pago", img: mp },
];

export const PaymentMethods = () => {
  const { customTheme }: { customTheme: CustomTheme } =
    useContext(ThemeContext);

  return (
    <Container customTheme={customTheme}>
      {payments.map((el, key) => (
        <PaymentRow
          key={key}
          title={el.title}
          img={el.img}
          isLast={key == +(payments.length - 1)}
        />
      ))}
    </Container>
  );
};
